import { render, staticRenderFns } from "./LocalizadorEndereco.vue?vue&type=template&id=50f1f076&scoped=true&"
import script from "./LocalizadorEndereco.vue?vue&type=script&lang=ts&"
export * from "./LocalizadorEndereco.vue?vue&type=script&lang=ts&"
import style0 from "./LocalizadorEndereco.vue?vue&type=style&index=0&id=50f1f076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f1f076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
